import React from 'react';
import { LIBRARY_APPROVE_MODULES } from '../store/rightsArray';

function RowCheckBox({ item, index, parentElement, parentIndex, onChangeCheckbox }) {
  return (
    <>
      <td style={{ width: '25%' }} height="43">
        {item?.label && (
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              name={`${parentIndex}_rightsArray_${index}_switchstatus`}
              id={`${parentIndex}_rightsArray_${index}_switchstatus`}
              onChange={onChangeCheckbox}
              checked={item?.switchstatus}
              className="custom-control-input"
            />
            <label htmlFor={`${parentIndex}_rightsArray_${index}_switchstatus`} className="custom-control-label">
              {item?.label}
            </label>
          </div>
        )}
      </td>
      <td>
        <div className="hidecheckbox hidecheckbox margin-auto">
          <input
            type="checkbox"
            name={`${parentIndex}_rightsArray_${index}_all`}
            id={`${parentIndex}_rightsArray_${index}_all`}
            onChange={onChangeCheckbox}
            checked={item?.all}
          />
          <label htmlFor={`${parentIndex}_rightsArray_${index}_all`} className="chklabel" />
        </div>
      </td>
      <td>
        <div className="hidecheckbox hidecheckbox margin-auto">
          <input
            type="checkbox"
            name={`${parentIndex}_rightsArray_${index}_addEdit`}
            id={`${parentIndex}_rightsArray_${index}_addEdit`}
            onChange={onChangeCheckbox}
            checked={item?.addEdit}
          />
          <label htmlFor={`${parentIndex}_rightsArray_${index}_addEdit`} className="chklabel" />
        </div>
      </td>
      <td>
        <div className="hidecheckbox hidecheckbox margin-auto">
          <input
            type="checkbox"
            name={`${parentIndex}_rightsArray_${index}_delete`}
            id={`${parentIndex}_rightsArray_${index}_delete`}
            onChange={onChangeCheckbox}
            checked={item?.delete}
          />
          <label htmlFor={`${parentIndex}_rightsArray_${index}_delete`} className="chklabel" />
        </div>
      </td>
      <td>
        {!item?.all && !item?.delete && !item?.approveReject && !item?.addEdit && (
          <div className="hidecheckbox hidecheckbox margin-auto">
            <input type="checkbox" name={`${parentIndex}_rightsArray_${index}_read`} id={`${parentIndex}_rightsArray_${index}_read`} checked={item?.read} />
            <label htmlFor={`${parentIndex}_rightsArray_${index}_read`} className="chklabel" />
          </div>
        )}
      </td>
      <td>
        {typeof item.approveReject === 'boolean' &&
          (parentElement?.name === 'products' || (parentElement?.name === 'libraries' && LIBRARY_APPROVE_MODULES.includes(item?.module))) && (
            <div className="hidecheckbox hidecheckbox margin-auto">
              <input
                type="checkbox"
                name={`${parentIndex}_rightsArray_${index}_approveReject`}
                id={`${parentIndex}_rightsArray_${index}_approveReject`}
                onChange={onChangeCheckbox}
                checked={item?.approveReject}
              />
              <label htmlFor={`${parentIndex}_rightsArray_${index}_approveReject`} className="chklabel" />
            </div>
          )}
      </td>
    </>
  );
}

export default RowCheckBox;
